import React, { Suspense } from 'react';
import {
  shape, string, bool, func
} from 'prop-types';
import { StoreLayout } from '@thd-olt-component-react/store-layout';

const Overlay = React.lazy(() => import(/* webpackChunkName: "overlay" */ '@thd-olt-component-react/core-ui')
  .then((module) => ({ default: module.Overlay })));

const StoreLayoutOverlay = ({
  onLayoutClick, storeId, storeName, aislebay
}) => {
//   const { channel } = useContext(ExperienceContext);
//   const store = useStore({ varnish: true, online: true });
  const { aisle, bay } = aislebay || {};
  return (
    <Suspense fallback={<div />}>
      <Overlay onClose={() => onLayoutClick(false)} open closeButton>
        <StoreLayout storeId={storeId} storeName={storeName} />
      </Overlay>
    </Suspense>
  );

};

StoreLayoutOverlay.displayName = 'StoreLayoutOverlay';

StoreLayoutOverlay.propTypes = {
  storeId: string.isRequired,
  onLayoutClick: func.isRequired,
  storeName: string.isRequired,
  aislebay: shape({
    aisle: string,
    bay: string
  })
};

StoreLayoutOverlay.defaultProps = {
  aislebay: {}
};

export { StoreLayoutOverlay };
